<template>
    <div class="position-relative">
        <v-app class="p-4">
            <div class="p-0 mt-5 pt-5 col-md-8 mx-auto" style="border: none!important;">
                <p class="mt-5">بسته موردنظر خود را با پرکردن تمامی فیلدهای درخواستی ایجاد کنید.</p>
                <v-row class="mt-5">
                    <v-col cols="12" md="6">
                        <v-text-field
                                v-model="title"
                                label="عنوان تعرفه"
                                required
                                dense
                                outlined
                                class="mt-1"
                                prepend-inner-icon="fa fa-pencil-alt"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                                v-model="price"
                                label="هزینه تعرفه (﷼)"
                                outlined
                                required
                                dense
                                prepend-inner-icon="fa fa-pencil-alt"
                                class="mt-1"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field
                                v-model="expireDate"
                                label="تاریخ انقضا(روز)"
                                outlined
                                required
                                dense
                                prepend-inner-icon="fa fa-pencil-alt"
                                class="mt-1"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-autocomplete
                                v-model="canDivert"
                                label="قابل دایورت"
                                :items="canDivertList"
                                item-text="name"
                                item-value="value"
                                outlined
                                required
                                dense
                                prepend-inner-icon="fa fa-pencil-alt"
                                class="mt-1"
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-autocomplete
                                v-model="roandLines"
                                label="خطوط رند"
                                :items="roandLinesList"
                                item-text="name"
                                item-value="value"
                                outlined
                                required
                                dense
                                prepend-inner-icon="fa fa-pencil-alt"
                                class="mt-1"
                        ></v-autocomplete>
                        <v-switch
                                v-model="isActive"
                                dense
                                label="وضعیت"
                                class="mt-1"
                        ></v-switch>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-autocomplete
                                v-model="returnedLines"
                                label="خطوط بازگشتی"
                                :items="returnedLinesList"
                                item-text="name"
                                item-value="value"
                                outlined
                                required
                                dense
                                prepend-inner-icon="fa fa-pencil-alt"
                                class="mt-1"
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-color-picker
                                v-model="color"
                                label="رنگ"
                                outlined
                                required
                                dense
                                class="mt-1"
                                mode="rgba"
                                dot-size="18"
                                show-swatches
                                swatches-max-height="135"
                        ></v-color-picker>
                    </v-col>
                </v-row>
                <div class="col-md-12 text-left">
                    <v-btn v-if="Object.keys(editProps).length ===0" class="mt-5 submit-btn float-left" @click="createTarefe" v-status="'admin_number_pack_store'">
                        <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                        ثبت تعرفه
                    </v-btn>
                    <v-btn v-else class="mt-5 submit-btn float-left" @click="UpdateTarefe" v-status="'admin_number_pack_store'">
                        <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                        به روز رسانی تعرفه
                    </v-btn>
                </div>
            </div>
        </v-app>
    </div>
</template>

<script>
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import Swal from "sweetalert2";

export default {
    name: "createTarefe",
    components: {TitleRibbon},
    props: {
        editProps: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            title: '',
            isActive: '',
            price: '',
            expireDate: '',
            canDivert: '',
            city: '',
            canDivertList: [
                {
                    id: 1,
                    name: 'قابل دایورت',
                    value: 'yes'
                },
                {
                    id: 2,
                    name: 'غیرقابل دایورت',
                    value: 'no'
                }
            ],
            returnedLines: '',
            returnedLinesList: [
                {
                    id: 1,
                    name: 'خطوط بازگشتی',
                    value: 'yes'
                },
                {
                    id: 2,
                    name: 'خطوط آزاد',
                    value: 'no'
                }
            ],
            roandLines: '',
            roandLinesList: [
                {
                    id: 1,
                    name: 'خطوط رند',
                    value: 'yes'
                },
                {
                    id: 2,
                    name: 'خطوط عادی',
                    value: 'no'
                }
            ],
            color: '#000000'
        }
    },
    methods: {
        createTarefe() {
            $.ajax({
                url: `${url}/admin/packs/numbers`,
                type: 'POST',
                fn:this.createTarefe,
                headers: {
                    ACCEPT: 'application/json',
                    AUTHORIZATION: Token,
                },
                data: {
                    title: this.title,
                    price: this.price,
                    status: this.isActive ? 'active' : 'inactive',
                    expire: this.expireDate,
                    data: {
                        'divert': this.canDivert,
                        'rond': this.returnedLines,
                        'return': this.roandLines,
                        color: this.color
                    }

                },
                msg: true,
            })
        },
        UpdateTarefe() {
            $.ajax({
                url: `${url}/admin/packs/numbers/${this.editProps.id}`,
                type: 'PUT',
                fn:this.UpdateTarefe,
                headers: {
                    ACCEPT: 'application/json',
                    AUTHORIZATION: Token,
                },
                data: {
                    title: this.title,
                    count: this.lineCount,
                    price: this.price,
                    status: this.isActive ? 'active' : 'inactive',
                    expire: this.expireDate,
                    data: {
                        'divert': this.canDivert,
                        'return': this.returnedLines,
                        'rond': this.roandLines,
                        color: this.color
                    }

                },
                msg: true,
            })
        },
        addValues() {
            this.title = this.editProps.title;
            this.price = this.editProps.price;
            this.isActive = this.editProps.Status == "active";
            this.expireDate = this.editProps.expire ? this.editProps.expire : '';
            this.canDivert = this.editProps.divert !== "" ? this.editProps.divert : '';
            this.returnedLines = this.editProps.returned !== "" ? this.editProps.returned : '';
            this.roandLines = this.editProps.rond ? this.editProps.rond : '';
            this.color = this.editProps.color ? this.editProps.color : '';
        }
    },
    mounted() {
      this.addValues();
      this.$route.meta.has_ribbon =Object.keys(this.editProps).length <=0
    }
}
</script>

<style>
.fa-pencil-alt {
    font-size: 1.3rem !important;
}
</style>